import { defineMessages } from 'react-intl';

import { fieldNames } from './model';

export const labels = defineMessages({
  [fieldNames.category]: {
    id: 'users.skills.add.form.category.label',
    defaultMessage: 'Category',
  },
  [fieldNames.skillId]: {
    id: 'users.skills.add.form.skill.label',
    defaultMessage: 'Skill',
  },
  [fieldNames.level]: {
    id: 'users.skills.add.form.level.label',
    defaultMessage: 'Level',
  },
});
